import { Fragment } from "react/jsx-runtime";

import { Flex } from "#shared/view/components/Flex";
import { InlineLoader } from "#shared/view/components/InlineLoader";
import { Space } from "#shared/view/components/Space";
import { Text } from "#shared/view/components/Text";

export const AnalyzeLoader = ({ text }: { text?: string }) => {
  return (
    <Flex align={"center"}>
      <InlineLoader size={"xs"} color="violet" />

      {text && (
        <Fragment>
          <Space w="xs" />
          <Text>{text}</Text>
        </Fragment>
      )}
    </Flex>
  );
};
